<div id="sapphire"></div>
#sapphire
  - for (i = 0; i < 60; i++)
    .cut